// extracted by mini-css-extract-plugin
module.exports = {"root":"Steps_root__3hN6x","step":"Steps_step__-4cUW","completed":"Steps_completed__1Jg8u","node":"Steps_node__2liGg","inProgress":"Steps_inProgress__3pUsI"};